import { Card, Header } from "semantic-ui-react";

import React, { useMemo } from "react";
import { useTranslation } from "react-i18next";

import Table from "../../../../ui/components/Table/Table";

import usePublisherPricesTableColumns from "../hooks/usePublisherPricesTableColumns";

import PublisherPricesActions from "./PublisherPricesActions";

export default function PublisherPrices({ publisher, organization }) {
	const { t } = useTranslation();

	const data = useMemo(
		() => Object.values(publisher.prices?.[organization.id] || {}),
		[organization.id, publisher.prices],
	);

	const columns = usePublisherPricesTableColumns({ publisher, organization });

	return (
		<>
			<Header as="h3">{t("defaultPricing", "Default pricing")}</Header>

			<Card fluid>
				<Card.Content>
					<Table data={data} columns={columns} footer={false} />
				</Card.Content>

				<Card.Content>
					<PublisherPricesActions publisher={publisher} organization={organization} />
				</Card.Content>
			</Card>
		</>
	);
}
